export const headers = {
  COLUMN: 'column',
  VALUE: 'value'
}



// WEBPACK FOOTER //
// ./src/components/ficheEspace/ficheConstante.js